import { Contract } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import i18next from 'i18next';
import middleware from 'middleware';
import { useEffect } from 'react';
import {
  useGetAgreementTemplate,
  useGetAgreementTemplateLightList,
} from 'services/templates/agreement-template';
import { TEMPLATE_TYPE } from 'services/templates/types';
import { addItem, findLowestAvailableId } from 'utils/dnd/dndUtilities';

interface IContractSideMenuAgreementsListProps {}

const ContractSideMenuAgreementsList =
  ({}: IContractSideMenuAgreementsListProps) => {
    const { values, setFieldValue, namePrefix, setErrors } = useFormikContractHelpers();

    const agreementLightList = useGetAgreementTemplateLightList();

    const selectedId = values.sideMenu?.customTemplate?.selectedId;

    const parentId = values.sideMenu?.customTemplate?.parentId;

    const agreementTemplate = useGetAgreementTemplate(
      selectedId ?? '',
      {
        notFoundPath: undefined,
        notFoundToastError: i18next.t('toast-message.not-found'),
      },
      !!selectedId,
      false
    );

    useEffect(() => {
      if (!!selectedId && agreementTemplate.data && parentId) {
        const contractTemplateForm =
          middleware.template.agreement.queryToFormItem(
            agreementTemplate.data,
            findLowestAvailableId(values.items)
          );

        if (contractTemplateForm) {
          setFieldValue(
            namePrefix,
            addItem(values.items, parentId, contractTemplateForm)
          );
          setFieldValue('sideMenu.customTemplate.selectedId', undefined);
          setErrors({})
        }
        console.log(
          'useEffect - agreementTemplate',
          selectedId,
          agreementTemplate.data
        );
      }
    }, [selectedId, agreementTemplate.data]);

    return (
      <Contract.SideMenu.TemplatesList.Wrapper
        templates={agreementLightList.data}
        templateType={TEMPLATE_TYPE.agreement}
        item={template => (
          <Contract.SideMenu.TemplatesList.ListItem
            key={template.id}
            template={template}
          />
        )}
      />
    );
  };

export default ContractSideMenuAgreementsList;
